import React, { Component } from "react";
import { Link } from "react-router-dom";
import DataTable from "react-data-table-component";

const data = [
  {
    id: 1,
    name: "Advanced Features of TalentLMS",
    category: "Samples",
    date: "11/03/2020"
  },
  {
    id: 2,
    name: "Content and TalentLMS",
    category: "Samples",
    date: "14/03/2020"
  },
  {
    id: 3,
    name: "Employee Training 101",
    category: "Samples",
    date: "22/03/2020"
  },
  {
    id: 4,
    name: "Introduction to TalentLMS",
    category: "Samples",
    date: "03/03/2020"
  }
];
const columns = [
  {
    name: "ID",
    selector: "id",
    sortable: true
  },
  {
    name: "Name",
    selector: "name",
    sortable: true
  },
  {
    name: "Category",
    selector: "category",
    sortable: true,
    right: true
  },
  {
    name: "Date",
    selector: "date",
    sortable: true,
    right: true
  },

  {
    name: "Options",
    selector: "year",
    sortable: true,
    right: true,
    cell: row => (
      <div className="d-flex">
        <div className="btn btn-light shadow-sm mx-1">
          <i class="fas fa-pencil-alt text-primary"></i>
        </div>
        <div className="btn btn-light shadow-sm mx-1">
          <i class="fas fa-times text-danger"></i>
        </div>
      </div>
    )
  }
];

export default class Branches extends Component {
  render() {
    return (
      <div className="pt-3">
        <div>
          <div className="container border shadow-sm p-0 bg-white">
            <div className="header bg-primary text-white">
              <div className="row m-0">
                <div className="col-md-6 p-3 d-flex align-items-center">
                  <h5 className="m-0">
                    <Link to="/admin/dashboard">Home</Link> /<b> Branches</b>
                  </h5>
                </div>
                <div className="col-md-6 d-flex justify-content-end align-items-center">
                  <Link to="/admin/add-branch" className="btn btn-dark float-right">Add Branch</Link>
                </div>
              </div>
            </div>

            <div className="users-container p-2">
              <DataTable
                noHeader={true}
                columns={columns}
                data={data}
                theme="solarized"
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}
